import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss']
})
export class EmailVerificationComponent implements OnInit {
  message: string = 'Verifying your email...';
  verified: boolean = false;
  error: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router
  ) {}

ngOnInit(): void {
  const oobCode = this.route.snapshot.queryParamMap.get('oobCode');

  if (!oobCode) {
    this.message = 'Invalid or expired verification link.';
    this.error = true;
    return;
  }

  this.http.post('api/email/verify-email', { oobCode }).subscribe({
    next: () => {
      this.message = '✅ Email verified successfully! Redirecting to sign in...';
      this.verified = true;

      setTimeout(() => {
        this.router.navigate(['/sign-in']);
      }, 3000);
    },
    error: () => {
      this.message = '❌ Verification failed. Link may be invalid or expired.';
      this.error = true;
    }
  });
}

}
